import React, { Component } from 'react';
import {
    InstantSearch,
    Hits,
    SearchBox,
    Highlight,
    RefinementList,
    Pagination,
    CurrentRefinements,
    ClearRefinements,
    Configure,
} from 'react-instantsearch/dom';
import { connectHits } from "react-instantsearch/connectors";
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import CustomHits from './ProjectsCustomHits'
import { firebaseAuth, logComponentLoad } from '../../../../config/constants'
import LargeProjectsNav from './LargeProjectsNav'

function Search(props) {

    const saleschargepaidUI = props.user.email == "ivanmworozi@gmail.com"
        ? <div>
            <h5>saleschargepaid</h5>
            <RefinementList attribute="saleschargepaid" />
        </div>
        :''

    return (
        <div >
            <Pagination />
            <CurrentRefinements />
            <ClearRefinements />
            <SearchBox showLoadingIndicator />
            <h5>DELIVERY</h5>
            <RefinementList attribute="orderdelivered" />
            <h5>PAYMENT</h5>
            <RefinementList attribute="paymentstatus" />
            <h5>SALES PERSON</h5>
            <RefinementList attribute="salesperson.name" />
            <h5>archived</h5>
            <RefinementList attribute="archived" />
            <br/>
            {saleschargepaidUI}
            

            
            <br />
            {/* <RefinementList attribute="gender" />
            <br />
            <RefinementList attribute="ageGroup" /> */}


            {/* <CustomTest /> */}


            {/* USE THE ORIGINAL HIT TO DISPLAY ORDER CARDS */}
            {/* <Hits hitComponent={Product} /> */}

        </div>
    );
}

const ConnectedCustomHits = connectHits(CustomHits);

class ProjectsSearchNow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderStatuses: [],
            designers: [],
            user: '',
            algoliaUser: null,
            isAdmin: false,
            refresh: false,
            awaitingRefresh: false,
            salesPeopleChoices: [],
            deliveryPersonChoices: [],
            algoliaUser:''
        }
    }

    setRefreshToTrue = () => {
        console.log("upx7710++++++++++ setRefreshToTrue");
        this.setState({
            refresh: true
        })
    }


    setRefreshToFalse = () => {
        console.log("upx77102++++++++++ setRefreshToFalse");
        this.setState({
            refresh: false
        })
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);

                }



            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }

    
    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject,null,3));

        logComponentLoad(returnObject, "ProjectsSearchNow");
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    render() {
        
        const cardListUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.isAdmin
            ? <ConnectedCustomHits
                setRefreshToFalse={this.setRefreshToFalse}
                setRefreshToTrue={this.setRefreshToTrue}
                refresh={this.state.refresh}
                awaitingRefresh={this.state.awaitingRefresh}
                user={this.state.user}
                //isAdmin={this.state.isAdmin}
                algoliaUser={this.state.algoliaUser} 
                platform={this.props.match.params.platform}/>
            : <h2>YOU ARE NOT AN AUTHORIZED</h2>


        const userEmail = this.state.user && this.state.user.email && this.state.algoliaUser
            ? <div>
                <h3>{this.state.user.email}</h3>
                <h4>{"" + this.state.algoliaUser.isAdmin}</h4>
            </div>
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("sales")
            ? <div>

                <Search user={this.state.user}/>

                {userEmail}

                {/* USE OUR OWN CUSTOM COMPONENT TO RENDER LIST */}
                {cardListUI}
            </div>
            : <h2>YOU ARE NOT AUTHORIZED</h2>

        return (
            <div>

                <LargeProjectsNav />

                <InstantSearch
                    appId="FV5Z3H1RLH"
                    apiKey="47a7fc285552681d28ae495990c85eca"
                    indexName="largeProjects"
                    refresh={this.state.refresh}
                >
                    <Configure
                        hitsPerPage={100}
                    />
                    {wholeUI}
                </InstantSearch>
            </div>)
    }
}

export default ProjectsSearchNow;



// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ProjectsSearchNow.js